const ERole = Object.freeze({
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_USER: "ROLE_USER",

})
const ERoles= Object.freeze([
    ERole.ROLE_ADMIN,
    ERole.ROLE_USER,
    ])


export { ERole as default, ERoles }